module.exports = __webpack_public_path__ + "assets/images/8443374067a18915c7b10c42e547a09b.png";